import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import Container from '@mui/system/Container';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppState } from '../../common/store/store';
import { MasterViewPage } from './MasterPage';



export const MessageSent = () => {

    const hash = useSelector((state: AppState) => state.messageSent.hash);


    React.useEffect(() => {
        window.scrollTo(0, 0);
        (window as any).dataLayer.push({
            'event': 'soumission_envoyee',
            'transaction_id': hash ?? 'noid-' + (new Date().toString())
        });
        //const response = sendEvent('conversion', { 'send_to': 'AW-16641471259/qFNpCI-2usMZEJvmov89', 'transaction_id': hash });

    }, []);

    return <MasterViewPage><Container sx={{ pt: 3 }}>
        <Typography variant='h1' style={{ textAlign: 'center', fontSize: '3em' }}>Soumission envoyée :)</Typography>
        <Box sx={{ alignItems: 'center', textAlign: 'center' }}>
            <Typography sx={{ m: 2 }}>Votre demande de soumission a été envoyé avec succès. Nous y ferons suite dans le plus bref délais.</Typography>
            <Typography sx={{ m: 2 }}>Merci !</Typography>
            <Link to="https://lespieuxprotech.com">lespieuxprotech.com</Link>
        </Box>
        <Box sx={{ minHeight: 150 }} />
    </Container></MasterViewPage>;
};
